import { Injectable, EventEmitter } from "@angular/core";
import { Observable, BehaviorSubject } from "rxjs/Rx";
import { Response } from "@angular/http";
// Interfaces
import {
	IService,
	IApplicationModel,
	IApplicationsModel,
	IApplicationForm,
	IApplicationCreate,
	IContact,
	IAWSS3,
	IApplication,
	IReviewerModel,
	IReviewersModel,
	IMemberShip,
	IRole
} from "../../interfaces";
// classes
import {
	ApplicationCreateForm,
	ApplicationForm,
	ApplicationModel,
	ApplicationStatus
} from "../../classes";
// Enums
import { ApplicationStatusEnum, RoleEnum } from "../../enums";
// Services
import { LogService } from "../log/log.service";
import { ServerService } from "../server/server.service";
import { HelperService } from "../helper/helper.service";
import { ReviewerService } from "../reviewer/reviewer.service";
import { UserService } from "../user/user.service";
import { StorageService } from "../storage/storage.service";
import { LoaderService } from "../loader/loader.service";
import { HasRolePipe } from "../../pipes/index";
import { INotify } from "../../interfaces/inotify";
import { environment } from "../../../../environments/environment.dev";
import { IPACEDModel } from "../../interfaces/ipacedmodel";

@Injectable()
export class ApplicationService implements IService {
	// implements local variables

	OnLevelSelected$ = new EventEmitter<number>(true);
	OnTermsAgreed$ = new EventEmitter<boolean>(true);

	_appsrv_asApplicant: boolean;
	_appsrv_asReviewer: boolean;
	_submitted = new BehaviorSubject<boolean>(false);
	_error = new BehaviorSubject<boolean>(false);

	_application = new BehaviorSubject<IApplicationModel>(undefined);
	_applications = new BehaviorSubject<IApplicationsModel>(undefined);
	//_reviewerapplications = new BehaviorSubject<IApplicationsModel>(undefined);
	_applicationInnerHtml: BehaviorSubject<string> = new BehaviorSubject<
		string
	>(undefined);
	_ApplicaitonInnerHtml: string; // stores innerhtml of the application tab
	_level: number;
	_termsAgreed: boolean;
	//isApplicant: boolean;
	//actAsAcep: boolean;

	_data: {
		applications: IApplicationsModel;
		application: IApplicationModel;
		submitted: boolean;
		statusChecked: boolean;
	};

	// implements IService
	name = "ApplicationService";
	test(name, value) {
		console.log("testing", name, value);
	}
	constructor(
		private _logSrv: LogService,
		private _userSrv: UserService,
		private _serverSrv: ServerService,
		private _helperSrv: HelperService,
		private _reviewerSrv: ReviewerService,
		private _storageSrv: StorageService,
		private _loaderSrv: LoaderService
	) { }

	get ERROR() {
		return this._error;
	}

	set Error(value: boolean) {
		this._error.next(value);
	}

	get LEVEL() {
		return this._level;
	}

	set Level(value: number) {
		this._level = value;
		this.OnLevelSelected$.emit(value);
	}

	get TERMS() {
		return this._termsAgreed;
	}

	set Terms(value: boolean) {
		this._termsAgreed = value;
		this.OnTermsAgreed$.emit(value);
	}

	get SUBMITTED() {
		return this._submitted;
	}

	set Submitted(value: boolean) {
		this._logSrv.Debug(this.name, ["setting submitted", value]);
		this.DATA.submitted = value;
		this._submitted.next(value);
	}

	get APPLICATIONMODEL() {
		return this._application;
	}

	set ApplicationModel(value: IApplicationModel) {
		this._logSrv.Debug(this.name, ["setting application model", value]);
		this.DATA.application = value;

		if (this._helperSrv.isUndefined(value)) {
			this.Submitted = false;
		} else {
			this.Submitted =
				value.Application.Status === ApplicationStatusEnum.Submitted;
		}
		this._application.next(value);

		// //SET ISAPPLICANT
		// this.isApplicant = (value.Application.Applicant.ContactId == this._userSrv.Data.contact.Id);
		// this.actAsAcep = !this.isApplicant;

		this._logSrv.Debug(this.name, [
			"set application",
			{ value: value, data: this._data }
		]);
	}

	get APPLICATIONSMODEL() {
		return this._applications;
	}

	set ApplicationsModel(value: IApplicationsModel) {
		this._logSrv.Debug(this.name, ["setting applications model", value]);

		this.DATA.applications = value;
		this._applications.next(value);
		this._logSrv.Debug(this.name, [
			"set applications",
			{ value: value, data: this._data }
		]);
	}

	get APPLICATION_INNER_HTML() {
		return this._applicationInnerHtml.asObservable();
	}

	set ApplicaitonInnerHtml(value: string) {
		this._logSrv.Debug(this.name, [
			"changing Applicaiton InnerHtml",
			value
		]);
		this._ApplicaitonInnerHtml = value;
		this._applicationInnerHtml.next(value);
	}

	// get REVIEWERAPPLICATIONS() {
	// 	return this._reviewerapplications;
	// }

	// set ReviewerApplications(value: IApplicationsModel) {
	// 	this._logSrv.Debug(this.name, ['setting ReviewerApplications model', value]);
	// 	this._reviewerapplications.next(value);
	// }

	get DATA() {
		if (this._data === undefined) {
			this._data = {
				application: undefined,
				applications: undefined,
				submitted: false,
				statusChecked: false
			};
		}
		return this._data;
	}

	// getApplications(
	// 	caller: string,
	// 	contactid: string
	// ): Observable<IApplicationsModel> {
	// 	const key = this._storageSrv.GetKey(this._storageSrv.KEY_APPLICATIONS);
	// 	// "api/application/contactid/{applicantid}/key/{apikey}",

	// 	//    const endpoint = this._userSrv.Data.contact.Role === RoleEnum.Applicant ?  `${this._helperSrv.ApiLocation}application/contactid/${contactid}/key/${key}` : `${this._helperSrv.ApiLocation}application/key/${key}`;

	// 	this._userSrv.Is_QC_Reviewer =
	// 		this._userSrv.Data.contact.Role === RoleEnum.QC;

	// 	const endpoint = this._userSrv.Is_QC_Reviewer
	// 		? `${this._helperSrv.ApiLocation}application/key/${key}`
	// 		: `${
	// 				this._helperSrv.ApiLocation
	// 		  }application/contactid/${contactid}/key/${key}`;

	// 	this._logSrv.Debug(this.name, [
	// 		"getApplications",
	// 		{ caller: caller, contactid: contactid, endpoint: endpoint }
	// 	]);

	// 	return this._serverSrv.GetWithAuth(caller, endpoint).map(response => {
	// 		try {
	// 			const body = response.json();
	// 			const data = <IApplicationsModel>body.Data;
	// 			const apps = data.Applications;
	// 			this.ApplicationsModel = data;
	// 			return data;
	// 		} catch (err) {
	// 			this._logSrv.Error(this.name, ["getApplications", err]);
	// 			return undefined;
	// 		}
	// 	});
	// }

	getApplications(caller: string, contactid: string): Observable<IPACEDModel> {
		const key = this._storageSrv.GetKey(this._storageSrv.KEY_APPLICATIONS);
		// "api/application/contactid/{applicantid}/key/{apikey}",

		//    const endpoint = this._userSrv.Data.contact.Role === RoleEnum.Applicant ?  `${this._helperSrv.ApiLocation}application/contactid/${contactid}/key/${key}` : `${this._helperSrv.ApiLocation}application/key/${key}`;

		const endpoint = `${this._helperSrv.ApiLocation
			}application/key/${key}/temp1/abc/pacedmodel/${contactid}`;

		return this._serverSrv.GetWithAuth(caller, endpoint).map(response => {
			try {
				const body = response.json();
				const data = <IPACEDModel>body.Data;
				const _apps = <IApplicationsModel>data.Applications;
				//const apps = data.apps.Applications;
				this.ApplicationsModel = _apps;
				this._userSrv.setContact("", data.Contact.Contact);

				this._userSrv.Is_QC_Reviewer =
					this._userSrv.Data.contact.Role === RoleEnum.QC;

				return data;
			} catch (err) {
				this._logSrv.Error(this.name, ["getApplications", err]);
				return undefined;
			}
		});
	}

	// getReviewerApplications(caller: string, contactid: string) {
	// 	const key = this._storageSrv.GetKey(this._storageSrv.KEY_APPLICATIONS);
	// 	// "api/application/contactid/{applicantid}/key/{apikey}",
	// 	const endpoint = `${this._helperSrv.ApiLocation}application/key/${key}`;
	// 	this._logSrv.Debug(this.name, ['getReviewerApplicationsALL', { caller: caller, contactid: contactid, endpoint: endpoint }]);

	// 	return this._serverSrv.GetWithAuth(caller, endpoint)
	// 		.map(response => {
	// 			try {
	// 				const body = response.json();
	// 				const data = <IApplicationsModel>body.Data;
	// 				const apps = data.Applications;
	// 				this.ReviewerApplications = data;
	// 				return data;
	// 			} catch (err) {
	// 				this._logSrv.Error(this.name, ['getReviewerApplicationsALL', err]);
	// 				return undefined;
	// 			}
	// 		});
	// }

	removeStorageKeys() {
		this._storageSrv.RemoveKey(this._storageSrv.KEY_APPLICATIONS);
		this._storageSrv.RemoveKey(this._storageSrv.KEY_APPLICATION);
		this._storageSrv.RemoveKey(this._storageSrv.KEY_STEP);
		this._storageSrv.RemoveKey(this._storageSrv.KEY_STEPS);
		this._storageSrv.RemoveKey(this._storageSrv.KEY_S3);
		this._storageSrv.RemoveKey(this._storageSrv.KEY_SALESORDER);
		//CLEAR KEYS
		this._storageSrv.RemoveKey(this._storageSrv.KEY_DISCUSSION_LEGENDS);
		this._storageSrv.RemoveKey(this._storageSrv.KEY_DISCUSSION_LEGENDSUSER);

		this.DATA.statusChecked = false;
	}

	refreshApplications(): Promise<IPACEDModel> {
		this.removeStorageKeys();
		return this.getApplications(
			this._userSrv.Data.contact.AcepId,
			this._userSrv.Data.contact.Id
		).toPromise();
		// if (this._appsrv_asReviewer) {
		// 	return this.getReviewerApplications(this._userSrv.Data.contact.AcepId, this._userSrv.Data.contact.Id).toPromise();
		// } else {
		// 	return this.getApplications(this._userSrv.Data.contact.AcepId, this._userSrv.Data.contact.Id).toPromise();
		// }
	}

	getApplication(
		caller: string,
		applicationid: string
	): Observable<IApplicationModel> {
		const key = this._storageSrv.GetKey(this._storageSrv.KEY_APPLICATION);
		// application/applicationid/{applicationid}/key/{apikey}
		const endpoint = `${this._helperSrv.ApiLocation
			}application/applicationid/${applicationid}/key/${key}`;
		this._logSrv.Debug(this.name, [
			"getApplication",
			{ caller: caller, applicationid: applicationid, endpoint: endpoint }
		]);

		return this._serverSrv.GetWithAuth(caller, endpoint).map(response => {
			const body = response.json();
			this._logSrv.Debug(this.name, [body]);
			const data = <IApplicationModel>body.Data;
			this.ApplicationModel = data;
			return data;
		});
	}

	refreshApplication(): Promise<IApplicationModel> {
		this._storageSrv.RemoveKey(this._storageSrv.KEY_APPLICATION);
		return this.getApplication(
			this._userSrv.Data.contact.AcepId,
			this.DATA.application.Application.Id
		).toPromise();
	}

	private UpdateApplicationFromParentApp(f: ApplicationForm) {
		let a = this._storageSrv.getLocal(this._storageSrv.KEY_UPGRADEAPP);
		if (a) {

			let app: IApplication = JSON.parse(a);
			f.AccountId = app.AccountId;
			f.AccountNumber = app.Hospital.AccountNumber;
			f.HospitalAddressCity = app.Hospital.Address.City;
			f.HospitalAddressState = app.Hospital.Address.State;
			f.HospitalAddressCountry = app.Hospital.Address.Country;
			f.CeoName = app.Hospital.CeoName;
			f.CeoId = app.Hospital.CeoId;
			f.CeoFirst = app.Hospital.CeoFirst;
			f.CeoLast = app.Hospital.CeoLast;
			f.CeoEmail = app.Hospital.CeoEmail;
			f.CeoRole = app.Hospital.CeoRole;
			f.HospitalAddressLine1 = app.Hospital.Address.Line1;
			f.HospitalAddressLine2 = app.Hospital.Address.Line2;
			f.HospitalAddressZip = app.Hospital.Address.PostalCode;
			f.HospitalName = app.Hospital.Name;
			f.HospitalPhone = app.Hospital.Phone.Num;
			f.HospitalCategoryId = app.Hospital.CategoryId;
			f.ParentId = app.Id;

			f.ApplicantPhone = app.Applicant.Phone.Num;
			f.ApplicantPhoneType = app.Applicant.Phone.Name;
			f.ApplicantPosition = app.Applicant.Position;

		}
	}

	CreateNewApplicationForm(contact: IContact): Promise<IApplicationForm> {
		// this.DATA.application = undefined;
		return new Promise((form, fail) => {
			const f = new ApplicationForm();
			f.SetApplicantContact(contact);
			f.AccountId = "guid".EmptyGuid();
			f.AccountNumber = this._helperSrv.newHospitalId;
			f.Status = ApplicationStatusEnum.Initiated;
			//check if parent app in local storage
			this.UpdateApplicationFromParentApp(f);

			this._logSrv.Debug(this.name, [
				"CreateNewApplicationForm resolve",
				f
			]);
			form(f);
		});
	}

	ConvertToApplicaitonForm(
		model: IApplicationModel
	): Promise<IApplicationForm> {
		return new Promise((resolve, fail) => {
			try {
				const a = new ApplicationModel();
				Object.keys(model).forEach(key => (a[key] = model[key]));
				const form = a.ConvertToForm();
				this._logSrv.Debug(this.name, [
					"ConvertToApplicaitonForm",
					form,
					a
				]);
				resolve(form);
			} catch (err) {
				this._logSrv.Error(this.name, [
					"ConvertToApplicaitonForm",
					err
				]);
				fail(err);
			}
		});
	}

	postApplication(a: IApplicationForm): Promise<IApplicationModel> {
		return new Promise((resolve, fail) => {
			const user = this._userSrv.Data.contact;
			const app = new ApplicationForm();
			app.GetApplication(a);
			this._logSrv.Debug(this.name, [
				"postApplication",
				{ user: user, app: app }
			]);

			const model = <IApplicationCreate>app.ConvertToCreateModel(user);
			const endPoint = `${this._helperSrv.ApiLocation}application`;
			this._logSrv.Debug(this.name, [
				"postApplication",
				{ user: user, model: model, endpoint: endPoint }
			]);

			if (1 === 1) {
				this._serverSrv
					.PostWithAuth(user.AcepId, endPoint, model)
					.toPromise()
					.then(
						response => {
							try {
								const body = response.json();
								const data = <IApplicationModel>body.Data;
								this.ApplicationModel = data;
								resolve(data);
							} catch (err) {
								this.ApplicationModel = undefined;
								fail(response.statusText);
							}
						},
						failToPost => {
							fail(failToPost);
						}
					);
			}
		});
	}

	putApplication(a: IApplicationForm): Promise<IApplicationModel> {
		return new Promise((resolve, fail) => {
			const user = this._userSrv.Data.contact;
			const app = new ApplicationForm();
			app.GetApplication(a);
			this._logSrv.Debug(this.name, [
				"putApplication",
				{ user: user, app: app }
			]);

			const model = <IApplicationCreate>app.ConvertToCreateModel(user);
			const endPoint = `${this._helperSrv.ApiLocation}application`;
			this._logSrv.Debug(this.name, [
				"putApplication",
				{ user: user, model: model, endpoint: endPoint }
			]);

			if (1 === 1) {
				this._serverSrv
					.PutWithAuth(user.AcepId, endPoint, model)
					.toPromise()
					.then(
						response => {
							try {
								const body = response.json();
								const data = <IApplicationModel>body.Data;
								this.ApplicationModel = data;
								resolve(data);
							} catch (err) {
								fail(response.statusText);
							}
						},
						failToPost => {
							fail(failToPost);
						}
					);
			}
		});
	}

	putApplicationFromModel(
		a: IApplicationModel,
		af: IApplicationForm
	): Promise<IApplicationModel> {
		return new Promise((resolve, fail) => {
			const user = this._userSrv.Data.contact;
			const app = new ApplicationForm();
			app.GetApplication(af);
			const model = <IApplicationCreate>app.ConvertToCreateModel(user);
			//below: tells the current app to update using the current app id.
			model.Id = a.Application.Id;

			const endPoint = `${this._helperSrv.ApiLocation}application`;
			this._logSrv.Debug(this.name, [
				"putApplication",
				{ user: user, model: model, endpoint: endPoint }
			]);

			if (1 === 1) {
				this._serverSrv
					.PutWithAuth(user.AcepId, endPoint, model)
					.toPromise()
					.then(
						response => {
							try {
								const body = response.json();
								const data = <IApplicationModel>body.Data;
								this.ApplicationModel = data;
								resolve(data);
							} catch (err) {
								fail(response.statusText);
							}
						},
						failToPost => {
							fail(failToPost);
						}
					);
			}
		});
	}

	updateApplicationStatus(s: ApplicationStatusEnum) {
		let app = this._data.application;
		let cancelling = s === ApplicationStatusEnum.Cancelled;
		this._logSrv.Debug(this.name, [
			"updateStatus",
			this._userSrv.Data,
			app,
			s.toString(),
			cancelling
		]);
		let status = {
			ApplicationId: app.Application.Id,
			Status: s,
			ContactId: this._userSrv.Data.contact.Id //._memberService.DataStore.SSO.user.ContactId
		};
		let endPoint = `${this._helperSrv.ApiLocation}application/status`;

		return this._serverSrv
			.PutWithAuthWithURL(
				this._userSrv.Data.contact.AcepId,
				endPoint,
				status
			)
			.map(m => m.json())
			.do(data => {
				"updatestatus application recieved after ".logWithObject(
					this.name,
					[data, cancelling]
				);
				// if application is in submitted status

				if (cancelling) {
					// this.setApplicationToNull(this.name);
				} else {
					//UPDATE STATUS AND TRANSMIT
					this._data.application.Application.Status = s;
					this.APPLICATIONMODEL.next(this._data.application);
					//let a = <IApplication>JSON.parse(data);
					//'updatestatus application recieved after '.logWithObject(this.name, a);
					this.Submitted =
						ApplicationStatus.GetEnum(s) ===
						ApplicationStatusEnum.Submitted;

					//this._data.application.Application = a;
					"updateStatus updating all applicaitons".logWithObject(
						this.name,
						this._userSrv.Data
					);
				}
				//this.get(this._userSrv.Data.contact.AcepId).subscribe();
			});
	}

	UpdateAndEmail(
		status: ApplicationStatusEnum,
		notify: INotify
	): Promise<INotify> {
		return new Promise((resolve, reject) => {
			let s = ApplicationStatusEnum[status];
			let app = this.DATA.application;
			this._logSrv.Debug(this.name, [
				"UpdateAndEmail Application is changing status",
				app,
				s
			]);
			// update the updateStatus
			this.updateApplicationStatus(status).subscribe(
				app => {
					this._logSrv.Debug(this.name, [
						"UpdateAndEmail Application received after" + s,
						app
					]);
					if (app && status !== ApplicationStatusEnum.Cancelled) {
						let returnedApp = <IApplication>JSON.parse(app);
						"UpdateAndEmail reset application".log(this.name);
						// this._applicationService.Application = returnedApp;

						//'UpdateAndEmail reset discussions'.log(this.name);
						//this.LoadDiscussions();
					}
					resolve(notify);
				},
				err => {
					this._logSrv.Error(this.name, ["UpdateAndEmail " + s, err]);
					// this._messageService.DisplayTopError('Unable to change status to ' + s, true);
					reject(err);
				}
			);

			// END PROMISE
		});
	}

	AssignToQC(): Promise<INotify> {
		return this.UpdateAndEmail(ApplicationStatusEnum.QC_Review, {
			acep: true,
			applicant: true,
			board: false,
			panel: false,
			internal: false,
			comment:
				`Application [` +
				this.DATA.application.Application.ApplicationNumber +
				`]: ` +
				this.DATA.application.Application.Name +
				` has been assigned to QC review`
		});
	}

	AssignToPanels(): Promise<INotify> {
		return this.UpdateAndEmail(ApplicationStatusEnum.Panel_Review, {
			acep: true,
			applicant: true,
			board: false,
			panel: true,
			internal: false,
			comment:
				`Application [` +
				this.DATA.application.Application.ApplicationNumber +
				`]: ` +
				this.DATA.application.Application.Name +
				` has been assigned to Panel review`
		});
	}

	// AssignToSiteReview(): Promise<INotify> {
	// 	return this.UpdateAndEmail(ApplicationStatusEnum.Site_Review, {
	// 		acep: true,
	// 		applicant: true,
	// 		board: false,
	// 		panel: false,
	// 		internal: false,
	// 		comment:
	// 			`Application [` +
	// 			this.DATA.application.Application.ApplicationNumber +
	// 			`]: ` +
	// 			this.DATA.application.Application.Name +
	// 			` has been assigned to Panel review`
	// 	});
	// }

	// /**
	//  * posts panelists and board members
	//  */
	// PostReviewers(appid: string, appnum: string, appdata: any, reviewers: IReviewerModel[], appstatus: ApplicationStatusEnum): Promise<IReviewerModel[]> {
	// 	return new Promise((resolve, fail) => {
	// 		this._logSrv.Debug(
	// 			this.name,
	// 			['posting list or reviewers ', 'this._helperSrv.PostingReviewers']);
	// 		this._data.application = appdata;

	// 		let body = {
	// 			applicationId: appid,
	// 			applicationStatus: appstatus,
	// 			Reviewers: reviewers
	// 		};

	// 		let endPoint = `${this._helperSrv.ApiLocation}reviewer/save`;

	// 		this._serverSrv.PostWithAuth(this._userSrv.Data.contact.AcepId, endPoint, JSON.stringify(body))
	// 			.toPromise()
	// 			.then(response => {
	// 				try {
	// 					const thisbody = response.json();
	// 					const data = <IReviewerModel[]>thisbody;
	// 					this._reviewerSrv.QCs = data;
	// 					resolve(data);
	// 				} catch (err) {
	// 					//this.ApplicationModel = undefined;
	// 					fail(response.statusText);
	// 				}
	// 			}, failToPost => {
	// 				fail(failToPost);
	// 			});
	// 	});
	// }

	getApplicationMemberRecord(appModel: IApplicationModel): IMemberShip {
		let im: IMemberShip = this._userSrv.Data.contact.Memberships.filter(
			m => m.ApplicationId == appModel.Application.Id
		)[0];
		return im;
	}

	RefreshRolesForContact(appModel: IApplicationModel) {
		let m: IMemberShip = this.getApplicationMemberRecord(appModel);
		//if no membership found..it implies its a QC (MASTER)
		let role = m ? m.Role : RoleEnum.QC;
		//if applicant.set it approproately
		if (
			this._userSrv.Data.contact.Id ==
			appModel.Application.Applicant.ContactId
		) {
			role = RoleEnum.Applicant;
		}
		this._userSrv.IROLE = {
			IsQC: role == RoleEnum.QC,
			IsPanel: role == RoleEnum.QC,
			IsBoard: role == RoleEnum.Board,
			ActingAsAcep: role != RoleEnum.Applicant,
			IsApplicant: role == RoleEnum.Applicant
		};
		//this._userSrv.ROLE.next(role);
		this._userSrv.Role = role;
	}

	NavigateToNextStep(CURRENTSTEP: string) {
		CURRENTSTEP = CURRENTSTEP.toLowerCase();
		let NEXTSTEP: string = CURRENTSTEP;
		let CURRENTLEVEL = this.Level;
		if (CURRENTLEVEL == undefined) {
			CURRENTLEVEL = this.DATA.application.Application.Level;
		}
		switch (CURRENTSTEP) {
			case "information": {
				NEXTSTEP = "program";
				break;
			}
			case "program": {
				NEXTSTEP = "Leadership";
				break;
			}
			case "leadership": {
				NEXTSTEP = "painManagement";
				break;
			}
			case "painmanagement": {
				NEXTSTEP = "NonOpioid";
				break;
			}
			case "nonopioid": {
				NEXTSTEP = "Stewardship";
				break;
			}
			case "stewardship": {
				NEXTSTEP = "nonPharmacologic";
				break;
			}
			case "nonpharmacologic": {
				NEXTSTEP = "quality";
				break;
			}
			case "quality": {
				NEXTSTEP = "submit";
				break;
			}
			case "submit": {
				break;
			}
		}

		if (NEXTSTEP != CURRENTSTEP) {
			this._helperSrv.goToLevelWithStep(
				this.DATA.application.Application.Level,
				this.DATA.application.Application.Id,
				NEXTSTEP
			);
		}
	}

	//these are QCS who are not QC for the particular site
	IsATeamMember(members: IReviewerModel[]): boolean {
		let contactid = this._userSrv.Data.contact.Id;
		let _isATeamMember = members
			? members.filter(a => a.Reviewer.ContactId == contactid).length > 0
			: false;
		return _isATeamMember;
	}

	getReviewerFromContactId(contactid: string): IReviewerModel {
		let r: IReviewerModel = null;
		if (this._reviewerSrv.Reviewers && contactid) {
			r = this._reviewerSrv.Reviewers.filter(
				r =>
					r.Reviewer.ContactId.toLowerCase() ==
					contactid.toLowerCase()
			)[0];
		}

		return r;
	}
}



// WEBPACK FOOTER //
// C:/AZURE/ACEP/Acep.Crm.WebPortal/CrmWebPortalGlobal/Membership/AngularApps/PACED/PACEDAngular/src/app/share/services/application/application.service.ts